import { render, staticRenderFns } from "./OrganizerList.vue?vue&type=template&id=b767c5d2"
import script from "./OrganizerList.vue?vue&type=script&lang=js"
export * from "./OrganizerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports